import { parse } from 'graphql';
import React from 'react';
import PropTypes from 'prop-types';
import QueryStore from '../utility/QueryStore';
import HistoryQuery from './HistoryQuery';
const MAX_QUERY_SIZE = 100000;
const MAX_HISTORY_LENGTH = 20;
const shouldSaveQuery = (query, variables, lastQuerySaved) => {
    try {
        parse(query);
    }
    catch (e) {
        return false;
    }
    if (query.length > MAX_QUERY_SIZE) {
        return false;
    }
    if (!lastQuerySaved) {
        return true;
    }
    if (JSON.stringify(query) === JSON.stringify(lastQuerySaved.query)) {
        if (JSON.stringify(variables) === JSON.stringify(lastQuerySaved.variables)) {
            return false;
        }
        if (variables && !lastQuerySaved.variables) {
            return false;
        }
    }
    return true;
};
export class QueryHistory extends React.Component {
    constructor(props) {
        super(props);
        this.updateHistory = (query, variables, operationName) => {
            if (shouldSaveQuery(query, variables, this.historyStore.fetchRecent())) {
                this.historyStore.push({
                    query,
                    variables,
                    operationName,
                });
                const historyQueries = this.historyStore.items;
                const favoriteQueries = this.favoriteStore.items;
                const queries = historyQueries.concat(favoriteQueries);
                this.setState({
                    queries,
                });
            }
        };
        this.toggleFavorite = (query, variables, operationName, label, favorite) => {
            const item = {
                query,
                variables,
                operationName,
                label,
            };
            if (!this.favoriteStore.contains(item)) {
                item.favorite = true;
                this.favoriteStore.push(item);
            }
            else if (favorite) {
                item.favorite = false;
                this.favoriteStore.delete(item);
            }
            this.setState({
                queries: [...this.historyStore.items, ...this.favoriteStore.items],
            });
        };
        this.editLabel = (query, variables, operationName, label, favorite) => {
            const item = {
                query,
                variables,
                operationName,
                label,
            };
            if (favorite) {
                this.favoriteStore.edit({ ...item, favorite });
            }
            else {
                this.historyStore.edit(item);
            }
            this.setState({
                queries: [...this.historyStore.items, ...this.favoriteStore.items],
            });
        };
        this.historyStore = new QueryStore('queries', props.storage, MAX_HISTORY_LENGTH);
        this.favoriteStore = new QueryStore('favorites', props.storage, null);
        const historyQueries = this.historyStore.fetchAll();
        const favoriteQueries = this.favoriteStore.fetchAll();
        const queries = historyQueries.concat(favoriteQueries);
        this.state = { queries };
    }
    render() {
        const queries = this.state.queries.slice().reverse();
        const queryNodes = queries.map((query, i) => {
            return (React.createElement(HistoryQuery, Object.assign({ handleEditLabel: this.editLabel, handleToggleFavorite: this.toggleFavorite, key: `${i}:${query.label || query.query}`, onSelect: this.props.onSelectQuery }, query)));
        });
        return (React.createElement("section", { "aria-label": "History" },
            React.createElement("div", { className: "history-title-bar" },
                React.createElement("div", { className: "history-title" }, 'History'),
                React.createElement("div", { className: "doc-explorer-rhs" }, this.props.children)),
            React.createElement("ul", { className: "history-contents" }, queryNodes)));
    }
}
QueryHistory.propTypes = {
    query: PropTypes.string,
    variables: PropTypes.string,
    operationName: PropTypes.string,
    queryID: PropTypes.number,
    onSelectQuery: PropTypes.func,
    storage: PropTypes.object,
};
//# sourceMappingURL=QueryHistory.js.map